import axios from '@axios'
import useJwt from '@core/auth/jwt/useJwt'
import jwtDefaultConfig from './jwtDefaultConfig'

const { jwt } = useJwt(axios, jwtDefaultConfig)
export default jwt
